//トップページ　キービジュアルスライダー

export function idxFunc() {
  let indexPage = $('#indexTop').length;

  if (indexPage) {
    let resizecheck = $('#responsibleCheck').width();
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

      //メインビュー
      wait(0)
      .then(() => {
          $('.fv .watch01').addClass('active');
          return wait(400)
      })
      .then(() => {
          $('.fv .watch02').addClass('active');
          return wait(400)
      })
      .then(() => {
          $('.fv .watch03').addClass('active');
          return wait(400)
      })

    window.addEventListener('resize', () => {
      resizecheck = $('#responsibleCheck').width();
    
      //アコーディオン初期化
    }, false);

    var animationStart = function () {
      const options = {
        root: null,
        threshold: 0,
      };
    
      const callback = (function (changes) {
        for (let change of changes) {
          let target = change.target;
          if (change.isIntersecting) {
            target.classList.add('active');
          }
        }
      });
    
      const observer = new IntersectionObserver(callback, options);
    
      const targets = document.querySelectorAll('.animation')
      for (let target of targets) {
        observer.observe(target)
      }
    }

    animationStart();

    var idxScrollFunc = function () {
      let trigger = document.getElementById("indexTop");
      let fixContent = $('#fixidContent');
      
      let triggerEnd = document.getElementById("shopList");
    
      let scrollValue = $(window).scrollTop();
      let clientRect = trigger.getBoundingClientRect();
      let clientRectEnd = triggerEnd.getBoundingClientRect();
      let py = window.pageYOffset + clientRect.top;
      let ey = window.pageYOffset + clientRectEnd.top;
    
      if (py < scrollValue && ey > scrollValue + window.innerHeight) {
        fixContent.addClass('show');
      } else {
        fixContent.removeClass('show');
      }
    }

    idxScrollFunc();

    $(window).on('scroll', function () {
      animationStart();
      idxScrollFunc();
    });
  }
}